(() => {
  if (window.elteeUSDeliveryBound) return;
  window.elteeUSDeliveryBound = true;
  let opener;
  let boundDialog;
  const bindDialog = (dialog) => {
    if (boundDialog === dialog) return;
    boundDialog = dialog;
    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || !dialog.open) return;
      const controls = [...dialog.querySelectorAll('button:not([disabled]), a[href]')];
      if (!controls.length) return;
      const index = controls.indexOf(document.activeElement);
      const nextIndex = event.shiftKey
        ? (index <= 0 ? controls.length - 1 : index - 1)
        : (index + 1) % controls.length;
      event.preventDefault();
      event.stopPropagation();
      controls[nextIndex].focus();
    }, true);
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('eltee-delivery-modal-open');
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-eltee-delivery-open]');
    const close = event.target.closest('[data-eltee-delivery-close]');
    if (!trigger && !close) return;
    const dialog = document.getElementById('ElteeUSDeliveryUpdate');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    event.stopPropagation();
    bindDialog(dialog);
    if (close) {
      dialog.close();
      return;
    }
    opener = trigger;
    if (!dialog.open) {
      dialog.showModal();
      document.documentElement.classList.add('eltee-delivery-modal-open');
    }
  }, true);
})();
